export default __webpack_public_path__ + "static/media/Warmonger's Mask.439a69f4.jpg";